import { Building2, CircleAlert, Clock3, FileCheck2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { StatisticCard } from '@/design-system';
import type { DashboardStats } from '../api/dashboard.service';

interface DashboardKpiCardsProps {
  stats: DashboardStats | null;
  isLoading: boolean;
}
export function DashboardKpiCards({ stats, isLoading }: DashboardKpiCardsProps) {
  const cards = [
    { title: 'Empresas', value: stats?.totalCompanies, icon: Building2, tone: 'primary' as const, href: '/companies' },
    { title: 'Assinaturas ativas', value: stats?.activeSubscriptions, icon: FileCheck2, tone: 'success' as const, href: '/companies' },
    { title: 'Em período de teste', value: stats?.trialingSubscriptions, icon: Clock3, tone: 'neutral' as const, href: '/companies' },
    { title: 'Assinaturas atrasadas', value: stats?.overdueSubscriptions, icon: CircleAlert, tone: 'warning' as const, href: '/companies' },
  ];
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {cards.map(({ href, value, ...card }) => (
        <Link key={card.title} to={href} className="rounded-xl transition-shadow hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30">
          <StatisticCard {...card} value={value ?? null} loading={isLoading} appearance="highlight" />
        </Link>
      ))}
    </div>
  );
}
